import { create } from "zustand";

type QuickAddStore = {
  abb: string;
  word: string;
  f10ID: string;
  listId: string;
};

export const useQuickAdd = create<QuickAddStore>((set, get) => ({
  abb: "",
  word: "",
  f10ID: "",
  listId: "",
}));

if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    if (newModule) {
      newModule.useQuickAdd.setState(useQuickAdd.getState());
    }
  });
}
